import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { Icon } from '../Icon/Icon';
import { Spinner } from '../Spinner/Spinner';
import { Text } from '../Text/Text';
import { AbsoluteContainer } from '../layout/AbsoluteContainer';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { RelativeContainer } from '../layout/RelativeContainer';
import { ButtonContainer } from './ButtonContainer';
import { useButtonColors } from './buttonConst';
const LoadingSpinner = ({ spinnerColorOverride }) => (_jsx(AbsoluteContainer, { top: 0, right: 0, bottom: 0, left: 0, children: _jsx(FlexContainer, { center: true, fullHeight: true, children: _jsx(Spinner, { size: 'small', spinnerColorOverride: spinnerColorOverride }) }) }));
export const Button = forwardRef(({ children, isDisabled: isDisabledPassed = false, color = 'grey', variant = 'light', textVariant = 'button', textFont, size = 'small', isLoading = false, testId, iconName, onClick, ...restProps }, ref) => {
    const buttonColorMap = useButtonColors({ variant, color });
    const testIdAttribute = useTestIdAttribute(testId);
    const isDisabled = isDisabledPassed || isLoading;
    const textColor = isDisabled
        ? buttonColorMap.text.disabledState
        : buttonColorMap.text.normalState;
    const textUnderline = variant === 'underline';
    const isChildrenString = typeof children === 'string';
    const buttonContent = isChildrenString ? (_jsx(Text, { colorOverride: textColor, variant: textVariant, underline: textUnderline, font: textFont, children: children })) : (children);
    const content = (_jsxs(FlexContainer, { gap: '1/2', center: true, children: [iconName && _jsx(Icon, { name: iconName, colorOverride: textColor }), buttonContent] }));
    const contentWithLoading = isLoading ? (_jsxs(_Fragment, { children: [_jsx(LoadingSpinner, { spinnerColorOverride: buttonColorMap.text.disabledState }), _jsx(Box, { opacity: 0, children: content })] })) : (content);
    const handleClick = (event) => {
        !isDisabled && onClick?.(event);
    };
    return (_jsx(ButtonContainer, { ref: ref, color: color, size: size, variant: variant, disabled: isDisabled, onClick: handleClick, ...testIdAttribute, ...restProps, children: _jsx(RelativeContainer, { children: contentWithLoading }) }));
});
